import { DataTable } from "@/src/components/ui/data-table";
import { useNavigate } from "react-router-dom";
import { AmenityGroup } from "./model";

export function AmenityGroupsTable({ amenityGroups }: { amenityGroups: AmenityGroup[] }) {
  const navigate = useNavigate();

  return (
    <div className="rounded-md bg-white border">
      <DataTable
        onRowClick={(r) => navigate(`/amenities/${r.id}`)}
        columns={[
          {
            header: "Name",
            accessorKey: "name",
          },
        ]}
        data={amenityGroups}
      />
    </div>
  );
}
